import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getBdBrands(data) {
    return request.get(`/${platform}/baidu/brands`,data)
}

export function storeOrUpdateBdBrand(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/baidu/brands/${data.id}` : `/${platform}/baidu/brands`;
    return request[method](url, data)
}

export function deleteBdBrand(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/baidu/brands/${ids}`)
}